class KlaviyoForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form");
    if (typeof KlaviyoSubscribe === "undefined") return;

    this.initFunction();
  }

  initFunction() {
    this.initKlaviyoForm();
    this.form.email.addEventListener("keypress", this.removeError.bind(this));
    this.form.addEventListener("submit", this.handleErrorValidation.bind(this));
  }

  initKlaviyoForm() {
    KlaviyoSubscribe.attachToForms(this.form, {
      hide_form_on_success: true,
      success: function ($form) {
        // `$form` is a jQuery wrapper
        $form.addClass("success");
      },
      extra_properties: {
        $source: "Shopify Form",
        $method_type: "Custom Klaviyo Form",
        $consent_version: "",
      },
    });
  }

  handleErrorValidation(event) {
    const email = this.form.email.value;
    const emailInput = this.form.email;
    const emailError = this.form.querySelector('.input-label__error');
    if (this.validateEmail(email)) {
      emailInput.classList.remove("error");
    } else {
      event.preventDefault();
      if (emailError.querySelector(".message")) {
        emailError.querySelector(".message").remove();
      }

      const errorMessage =
        this.form.email.dataset.errorMessage ||
        "Please enter a valid email address";
      emailError.innerHTML = errorMessage;
      emailInput.classList.add("error");
    }
  }

  removeError() {
    this.form.email.classList.remove("error");
  }

  validateEmail(email) {
    if (new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}").test(email)) {
      return true;
    }

    return false;
  }
}

if (!customElements.get("klaviyo-form")) {
  customElements.define("klaviyo-form", KlaviyoForm);
}
